interface Props {
  file: File | null
  alt: string
}

export function IconPreview({ file, alt }: Props) {
  if (!file) return null

  return (
    <img
      src={URL.createObjectURL(file)}
      className="absolute top-0 w-full h-full"
      alt={alt}
    />
  )
}
